"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_message_language_service_client_js_1 = require("@synisys/idm-message-language-service-client-js");
var material_1 = require("@angular/material");
var process_import_export_service_1 = require("../../services/process-import-export.service");
var ImportExportDialogComponent = /** @class */ (function () {
    function ImportExportDialogComponent(messageService, data, dialogRef, processImportExportService) {
        this.messageService = messageService;
        this.data = data;
        this.dialogRef = dialogRef;
        this.processImportExportService = processImportExportService;
        this.importFile = null;
        this.note = '';
        this.error = '';
        this.type = data.type;
        this.processId = data.processId;
    }
    ImportExportDialogComponent.prototype.importProcess = function () {
        var _this = this;
        this.processImportExportService.importProcess(this.processId, this.note, this.importFile.file).subscribe(function (res) {
            _this.dialogRef.close();
        }, function (error) {
            _this.importFile.error = 'workflow_designer.import_error_' + ((error && error.error && error.error.type) || 'unknown');
        });
    };
    ImportExportDialogComponent.prototype.exportProcess = function () {
        var _this = this;
        this.processImportExportService.exportProcess(this.processId, this.note).subscribe(function (res) {
            _this.downloadFile('workflow_' + res.process.id + '.json', JSON.stringify(res));
            _this.dialogRef.close();
        });
    };
    ImportExportDialogComponent.prototype.getMessage = function (key) {
        return this.messageService.getMessage(key);
    };
    ImportExportDialogComponent.prototype.updateNote = function (file) {
        if (file && file.data) {
            var data = JSON.parse(file.data);
            if (data && data.note) {
                this.note = data.note || '';
                return;
            }
        }
        this.note = '';
    };
    ImportExportDialogComponent.prototype.downloadFile = function (filename, text, type) {
        if (type === void 0) { type = 'text/plain'; }
        var link = document.createElement('a');
        link.setAttribute('target', '_blank');
        if (Blob !== undefined) {
            var blob = new Blob([text], { type: type });
            link.setAttribute('href', URL.createObjectURL(blob));
        }
        else {
            link.setAttribute('href', 'data:' + type + ',' + encodeURIComponent(text));
        }
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    ImportExportDialogComponent.decorators = [
        { type: core_1.Component, args: [{
                    
                    selector: 'sis-import-export-dialog-component',
                    styles: [require('./import-export-dialog.component.css')],
                    template: require('./import-export-dialog.component.html')
                },] },
    ];
    /** @nocollapse */
    ImportExportDialogComponent.ctorParameters = function () { return [
        { type: idm_message_language_service_client_js_1.MessageService, },
        { type: undefined, decorators: [{ type: core_1.Inject, args: [material_1.MAT_DIALOG_DATA,] },] },
        { type: material_1.MatDialogRef, },
        { type: process_import_export_service_1.ProcessImportExportService, },
    ]; };
    return ImportExportDialogComponent;
}());
exports.ImportExportDialogComponent = ImportExportDialogComponent;
//# sourceMappingURL=import-export-dialog.component.js.map